<template>
  <div class="widget-wrap margin-bottom-0" style="padding-bottom:0px">
    <div class="widget-header block-header margin-bottom-0 clearfix">
      <div>
        <h3>
          <span class="pull-left">歷史紀錄</span>
          <div class="pull-right form-group" style="margin-bottom:0px;">
            <div role="group" aria-label="..." class="btn-group">
              <a @click="select='note'" class="btn btn-default pointer" v-bind:class="{active: select == 'note'}">
                <i class="zmdi zmdi-comments"></i> 留言({{countActivities('note')}})
              </a>
              <a @click="select='event'" class="btn btn-default pointer" v-bind:class="{active: select == 'event'}">
                <i class="fa fa-calendar"></i> 待辦事項({{countActivities('event')}})
              </a>
              <a @click="select='attachment'" class="btn btn-default pointer" v-bind:class="{active: select == 'attachment'}">
                <i class="fa fa-paperclip"></i> 檔案({{countActivities('attachment')}})
              </a>
              <a @click="select='stage'" class="btn btn-default pointer" v-bind:class="{active: select == 'stage'}">
                <i class="fa fa-clock"></i> 交易狀態({{countActivities('stage')}})
              </a>
              <a @click="select='all'" class="btn btn-default pointer" v-bind:class="{active: select == 'all'}">
                全部({{activities.length}})
              </a>
            </div>
          </div>
        </h3>
      </div>
    </div>
    <div class="widget-container history-box margin-top-0">
      <div class="widget-content">
        <div class="activities-container">
          <ul class="text-left history-line">
            <div v-if="filterActivities.length == 0">
              <h4 class="text-center">
                <p style="padding:30px;" v-if="select=='all'">無任何歷史紀錄<br><br>可透過『新增留言』，『新增待辦事項』，『上傳檔案』等按鈕留下案件紀錄。</p>
                <span v-if="select=='note'">無留言</span>
                <span v-if="select=='event'">無沒有待辦事項</span>
                <span v-if="select=='attachment'">無沒有檔案</span>
                <span v-if="select=='stage'">無交易狀態變化</span>
              </h4>
            </div>
            <div v-else v-for="activity in filterActivities" class="activities-list">
              <li v-if="activity.content_type == 'stage' || activity.content_type == 'add_contact'">
                <div class="activities-badge">
                  <span class="w_bg_amber">
                      <i class="fa fa-file-invoice-dollar"></i>
                    </span>
                </div>
                <div class="activities-details">
                  <h3 class="activities-header">交易狀態： {{activity.content}}</h3>
                  <div class="activities-meta">
                    <i class="fa fa-clock-o "></i> {{activity.created_at | moment("YYYY/MM/DD a h:mm:ss ")}}
                    <i class="fa fa-user"></i>{{activity.user_name}}
                  </div>
                </div>
              </li>
              <li v-if="activity.content_type == 'event'">
                <div class="activities-badge">
                  <span class="w_bg_red">
                      <i class="fa fa-calendar"></i>
                    </span>
                </div>
                <div class="activities-details">
                  <div class="pull-right history-edit-box">
                    <a v-if="activity.activity_status=='doing'" class="row-edit" @click="activity.activity_status='finish';updateActivity(activity)"><i class="fa fa-check text-gray"></i></a>
                    <a v-else class="row-edit" @click="activity.activity_status='doing';updateActivity(activity)"><i class="fas fa-check-circle text-gray text-success"></i></a>
                  </div>
                  <h3 class="activities-header">待辦事項：
                    <span class="activities-meta">
                      <i class="fa fa-clock-o"></i> {{showActivityTime(activity)}}
                      <i class="fa fa-user"></i> {{activity.user_name}}
                    </span>
                  </h3>
                  <div class="activities-post">
                    <p v-html="getActivityCategory(activity)"></p>
                    <p v-if="activity.location != ''"><i class="fas fa-map-marker"></i> {{activity.location}}</p>
                    <pre v-if="activity.content.length > 0">{{activity.content}}</pre>
                  </div>
                </div>
              </li>
              <li v-else-if="activity.content_type == 'attachment'">
                <div class="activities-badge">
                  <span class="w_bg_deep_purple">
                      <i class="fa fa-paperclip"></i>
                    </span>
                </div>
                <div class="activities-details">
                  <h3 class="activities-header">上傳檔案：
                    <span class="activities-meta">
                      <i class="fa fa-clock-o"></i>{{activity.created_at | moment("YYYY/MM/DD a h:mm:ss ")}}
                      <i class="fa fa-user"></i>{{activity.user_name}}
                    </span>
                  </h3>
                  <div class="activities-post">
                    <ul class="new-comments-lists">
                      <li class="log_content">
                        <a target="_blank" v-bind:href="activity.attachment.url">{{activity.title || activity.attachment.file_name}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li v-else-if="activity.content_type == 'note'">
                <div class="activities-badge">
                  <span class="w_bg_teal">
                    <i class="zmdi zmdi-comments"></i>
                  </span>
                </div>
                <div class="activities-details">
                  <div class="pull-right history-edit-box" v-if="activity.edit!=activity.content">
                    <a class="row-edit" @click="activity.edit=activity.content; content_cache=activity.content"><span class="zmdi zmdi-edit"></span></a>
                    <a class="row-edit" @click="deleteActivity(activity)"><span class="zmdi zmdi-close"></span></a>
                  </div>
                  <h3 class="activities-header">留言
                    <span class="activities-meta">
                      <i class="fa fa-clock-o"></i>{{activity.created_at | moment("YYYY/MM/DD a h:mm:ss ")}}
                      <i class="fa fa-user"></i>{{activity.user_name}}
                    </span>
                  </h3>
                  <div class="activities-post">
                    <ul class="new-comments-lists">
                      <li v-show="activity.edit=='no' || activity.edit!=activity.content" class="log_content">{{activity.content}}</li>
                      <div class="j-forms" v-show="activity.edit==activity.content">
                        <div class="form-content">
                          <div class="unit">
                            <div class="input">
                              <label for="textarea">
                              </label>
                              <textarea class="form-control" placeholder="新增註記內容" v-model="content_cache" @keydown="content_type='note'"></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="form-footer">
                          <button class="btn btn-info primary-btn" v-on:click="activity.edit='no'">取消</button>
                          <button class="btn btn-info primary-btn" v-on:click="activity.edit='no'; activity.content=content_cache; updateActivity(activity)">更新</button>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from '../../assets/js/elffy_js/cookie.js'
import moment from 'moment';
export default {
  name: 'History',
  data() {
    return {
      content_cache: '',
      select: 'note',
    }
  },
  created() {
    moment.locale('zh-tw');
  },
  props: ['activities','activity_categories'],
  computed: {
    filterActivities: function(){
      let vm = this
      let result = this.activities.sort( ( a, b) => {
        return new Date(b.start) - new Date(a.start);
      });

      if(vm.select!="all"){
        if(vm.select == 'stage'){
          result = result.filter(function(e){
            return e.content_type == "stage" || e.content_type=="add_contact"
          })
        }else{
          result = result.filter(function(e){
            return e.content_type == vm.select
          })
        }
      }

      return result
    }
    
  },
  methods: {
    countActivities(type){
      var as= []
      var result = ''
      switch(type){
        case 'stage':
          as = this.activities.filter(function(a){
            return a.content_type == "stage" || a.content_type=="add_contact"
          })
          result = as.length
          break;
        case 'event':
          as = this.activities.filter(function(a){
            return a.content_type == "event"
          })
          var finished = as.filter(function(a){
            return a.activity_status == "finish"
          })
          if(as.length == 0){
            result =  0
          }else{
            result =  finished.length+'/'+as.length 
          }
          break;
        default: 
          as = this.activities.filter(function(a){
            return a.content_type == type
          })
          result = as.length
          break;
      }
      return result
    },
    moment() {
      return moment();
    },
    showActivityTime(activity){
      var a = ""
      var start = ""
      var end = ""
      if(activity.allDay){
        start = moment(activity.start).format('YYYY/MM/DD')
        end = moment(activity.end).format('YYYY/MM/DD')
        //校正因為allDay產生的end day 選擇時，時間多1天的問題
        end = moment(this.addDays(new Date(end),-1)).format('YYYY/MM/DD')
        //如果未來能解決，此段拿掉
        if(start==end){
          end = null
        }
      }else{
        start = moment(activity.start).format('YYYY/MM/DD a hh:mm ')
        end = moment(activity.end).format('YYYY/MM/DD a hh:mm ')
      }
      if(activity.end!=null && end!= null){
        a = start + ' ~ ' + end
      }else{
        a = start
      }
      return a
    },
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    getActivityCategory(activity){
      let vm=this
      var result = ""
      $.each(vm.activity_categories,function(key,category){
        if(category.id == activity.activity_category_id){
          result = '<i class="'+ category.icon +'"></i> <span>'+category.title+'</span> : <span>'+activity.title+'</span>'
        }
      })
      if(result==""){
        result = '<span>'+activity.title+'</span>'
      }
      return result
    },
    updateActivity(activity) {
      const vm = this;
      this.axios.put('activities/'+activity.id, {
          activity: activity
        })
        .then(function(response) {
          if (response.status == 200) {} else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    deleteActivity(activity) {
      // delete in html
      var index = this.activities.indexOf(activity)
      this.activities.splice(parseInt(index), 1)
      const vm = this;
      this.axios.delete('activities/'+activity.id, {
        activity: activity
      })
      .then(function(response) {
        if (response.status == 200) {} else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
  }
}
</script>


// WEBPACK FOOTER //
// History.vue?2b184bbd